import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TEnableWorkerInstantPayRequestSchema } from "./enableWorkerInstantPay.schema";
import { getWorkerPathFromUserType } from "../../utils/utils";

export const enableWorkerInstantPay = (axios: IAxiosInstance) => {
  return async (data: TEnableWorkerInstantPayRequestSchema) => {
    const { worker_id, worker_type } = data;

    const workerTypePath = getWorkerPathFromUserType(worker_type);

    const response = await axios.noRetry.post(
      `/api/${workerTypePath}/${worker_id}/instant-pay/onboard`
    );

    return response; // returns 204 no data
  };
};
